import Table from "./Table";
import AddCurrency from "./AddCurrency";
import "./style.css";
import MessageProvider from "./Context";

const Hotel = () => {
  return (
    <div className="container">
      <MessageProvider>
        <Table />
        <AddCurrency />
      </MessageProvider>
    </div>
  );
};

export default Hotel;
